module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.newSearchQuery($event)
      }
    }
  }, [_c('div', {
    staticClass: "search-form"
  }, [_c('div', {
    staticClass: "search-form__box search-form__box--select"
  }, [_c('span', {
    staticClass: "select select--search"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSearchParamsParam),
      expression: "newSearchParamsParam"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newSearchParamsParam = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.$lang.search.form.select.params), function(param) {
    return _c('option', {
      domProps: {
        "value": param.val
      }
    }, [_vm._v(_vm._s(param.name))])
  }))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "search-form__box search-form__box--input suggestion"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSearchParamsKey),
      expression: "newSearchParamsKey"
    }],
    staticClass: "input--search",
    attrs: {
      "type": "text",
      "placeholder": _vm.$lang.search.form.input.placeholder
    },
    domProps: {
      "value": (_vm.newSearchParamsKey)
    },
    on: {
      "keydown": _vm.autocompleteKeyHandler,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newSearchParamsKey = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.suggestions && _vm.suggestions.length > 0 && !_vm.activeAutocompleteDropdown && _vm.newSearchParamsKey) ? _c('ul', {
    staticClass: "suggestions__list"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('li', {
      staticClass: "suggestions__list--item suggestion"
    }, [_c('a', {
      ref: "autocompleteList",
      refInFor: true,
      staticClass: "suggestion__anchor",
      attrs: {
        "data-autocomplete": index
      },
      domProps: {
        "innerHTML": _vm._s(_vm.autocompleteHighlightLetters(suggestion, _vm.activeSuggestTmp))
      },
      on: {
        "click": function($event) {
          _vm.autocompleteSetSuggestion(suggestion)
        },
        "mouseenter": function($event) {
          _vm.autocompleteListMouseEnter($event)
        },
        "mouseleave": function($event) {
          _vm.autocompleteListMouseLeave($event)
        }
      }
    })])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "search-form__box search-form__box--button"
  }, [_c('button', {
    staticClass: "button--search",
    attrs: {
      "type": "submit",
      "disabled": !_vm.newSearchParamsKey,
      "title": _vm.$lang.search.form.button.search
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/search.svg"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cf98d0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Search/SearchForm.vue
// module id = 331
// module chunks = 1